// BidHistory.js
import React, { useEffect, useState } from "react";
import "./BidHistory.css";
import {useDispatch } from "react-redux";
import { getCharts } from "../features/userSlice";
import { useNavigate, useParams } from "react-router-dom";

const ChartCompo = () => {
    const {chart_ype,gameName}=useParams();
    const navigate=useNavigate();
    const dispatch=useDispatch();
    const [dataWeek_jodi,setdataWeek_jodi]=useState([]);
     
    // const dataWeek_jodi=[{mon:'11',tue:'12',wed:'13',thu:'14',fri:'15',sat:'16',sun:'17'},{mon:'11',tue:'12',wed:'13',thu:'14',fri:'15',sat:'16',sun:'17'},{mon:'11',tue:'12',wed:'13',thu:'14',fri:'15',sat:'16',sun:'17'},{mon:'11',tue:'12',wed:'13',thu:'14',fri:'15',sat:'16',sun:'17'}]

    
    const  sumOfDigits=(number)=> {
      if( number ){
      return number
        .toString() // Convert number to string
        .split("") // Split string into individual digits
        .map(Number) // Convert each character back to a number
        .reduce((acc, digit) => acc + digit, 0) % 10 || '0'; // Sum up the digits
      }else{
        return '*';
      }
    }

    
    const fetchData = async () => {
      try {
        let dataSet = new FormData();
        dataSet.append('game_name',gameName.split('_').join(' '));
        dataSet.append('type',chart_ype);
        const result =  await dispatch(getCharts(dataSet)).unwrap();
        if(result.success){
          setdataWeek_jodi(result.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } 
    };

  useEffect (()=>{
       
        fetchData()
     
     },[])

     
     
     

  return (
    <div className="">
        <div className="header_div_table">
        <div className="tbl_header">{gameName.split('_').join(' ')}</div>
        <br/>
        <div><button className="tbl_button">Go to bottom</button></div>
        </div><br/>
      <div className="table-wrapper">
        <table className=" table_borderChart_history_table bid-history-table">
          <thead className=" table_border tbl_head_new">
            <tr className="table_border">
              <th className="table_border">Date</th>
              <th className="table_border">Mon</th>
              <th className="table_border">Tue</th>
              <th className="table_border">Wed</th>
              <th className="table_border">Thu</th>
              <th className="table_border">Fri</th>
              <th className="table_border">Sat</th>
              <th className="table_border">Sun</th>
            </tr>
          </thead>
          <tbody className="table_border">
            {dataWeek_jodi?.map((bid, index) => (
              (chart_ype==='jodi_chart')?
              
              <tr key={index}>
                <td className="table_border">{bid.date || '**'}</td>
                <td className="table_border">{bid.mon || '**'}</td>
                <td className="table_border">{bid.tue || '**'}</td>
                <td className="table_border">{bid.wed || '**'}</td>
                <td className="table_border">{bid.thu || '**'}</td>
                <td className="table_border">{bid.fri || '**'}</td>
                <td className="table_border">{bid.sat || '**'}</td>
                <td className="table_border">{bid.sun || '**'}</td>
                
              </tr>:
              <tr key={index}>
                <td className="table_border">
                <div className="table_border_pana">
                      <div class="star-horizontal">{bid.date}</div>
                </div>
              </td>
               <td className="table_border">
                <div className="table_border_pana">
                      <div class="star-vertical">{bid.mon.open_panna}</div>
                      <div class="star-horizontal">{`${sumOfDigits(bid.mon.open_panna)}${sumOfDigits(bid.mon.close_panna)}`}</div>
                      <div class="star-vertical">{bid.mon.close_panna}</div>
                </div>
              </td>
              <td className="table_border">
                <div className="table_border_pana">
                      <div class="star-vertical">{bid.tue.open_panna}</div>
                      <div class="star-horizontal">{`${sumOfDigits(bid.tue.open_panna)}${sumOfDigits(bid.tue.close_panna)}`}</div>
                      <div class="star-vertical">{bid.tue.close_panna}</div>
                </div>
              </td>
              <td className="table_border">
                <div className="table_border_pana">
                      <div class="star-vertical">{bid.wed.open_panna}</div>
                      <div class="star-horizontal">{`${sumOfDigits(bid.wed.open_panna)}${sumOfDigits(bid.wed.close_panna)}`}</div>
                      <div class="star-vertical">{bid.wed.close_panna}</div>
                </div>
              </td>
              <td className="table_border">
                <div className="table_border_pana">
                      <div class="star-vertical">{bid.thu.open_panna}</div>
                      <div class="star-horizontal">{`${sumOfDigits(bid.thu.open_panna)}${sumOfDigits(bid.thu.close_panna)}`}</div>
                      <div class="star-vertical">{bid.thu.close_panna}</div>
                </div>
              </td>
              <td className="table_border">
                <div className="table_border_pana">
                      <div class="star-vertical">{bid.fri.open_panna}</div>
                      <div class="star-horizontal">{`${sumOfDigits(bid.fri.open_panna)}${sumOfDigits(bid.fri.close_panna)}`}</div>
                      <div class="star-vertical">{bid.fri.close_panna}</div>
                </div>
              </td>
              <td className="table_border">
                <div className="table_border_pana">
                      <div class="star-vertical">{bid.sat.open_panna}</div>
                      <div class="star-horizontal">{`${sumOfDigits(bid.sat.open_panna)}${sumOfDigits(bid.sat.close_panna)}`}</div>
                      <div class="star-vertical">{bid.sat.close_panna}</div>
                </div>
              </td>
              <td className="table_border">
                <div className="table_border_pana">
                      <div class="star-vertical">{bid.sun.open_panna}</div>
                      <div class="star-horizontal">{`${sumOfDigits(bid.sun.open_panna)}${sumOfDigits(bid.sun.close_panna)}`}</div>
                      <div class="star-vertical">{bid.sun.close_panna}</div>
                </div>
              </td>
              
            </tr>
            ))}
          </tbody>
        </table><br/>
        <div><button className="tbl_button">Go to top</button></div>
      </div>
      <br/><br/><br/>
    </div>
    
  );
};

export default ChartCompo;

